import {ImgHTMLAttributes} from "react"
import {styled} from "@mui/material/styles"

import mastercardLogo from "./mastercard.svg"
import visaLogo from "./visa.svg"
import redExclamationMark from "./red-exclamation-icon.svg"
import eligible from "./green-check-icon.svg"
import exclamationMark from "./exclamation-mark.svg"
import closeIcon from "./close-icon.svg"
import crossIconImage from "./cross-icon.svg"
import thickIconImage from "./thick-icon.svg"
import invalidCodeImage from "./invalid-code.svg"
import paymentProcessingImage from "./payment-processing.svg"
import paymentCompletedImage from "./payment-completed.svg"
import amountIcon from "./amount-icon.svg"
import frequencyIcon from "./frequency-icon.svg"
import startDateCalendarIcon from "./start-date-calendar-icon.svg"
import endDateCalendarIcon from "./end-date-calendar-icon.svg"
import setupSucceededLogo from "./setup-succeeded-logo.svg"
import addToCalendarIcon from "./add-to-calendar.svg"
import googleIcon from "./google-icon.svg"
import appleIcon from "./apple-icon.svg"
import outlookIcon from "./outlook-icon.svg"
import yellowExclamationIcon from "./yellow-exclamation-icon.svg"
import clockIcon from "./clock-icon.svg"
import greenCheckIconV2 from "./green-check-icon-v2.svg"
import redCrossIcon from "./red-cross-icon.svg"
import reoccuringDollarIcon from "./reoccuring-dollar.svg"
import errorIcon from "./error-icon.svg"
import watchIcon from "./watch-icon.svg"
import wallet from "./wallet.svg"
import BankAccount from "./bank-account.svg"
import DebitCard from "./debit-card.svg"
import calendarCheckIcon from "./calendar-check-icon.svg"
import oxxoLogo from "./oxxo-logo.svg"
import indebtedLogo from "./indebted-logo.svg"
import chevronForwardIcon from "./chevron.forward.svg"
import indebtedLogoWithText from "./indebted-logo-with-text.svg"
import lock from "./lock.svg"
import today from "./today.svg"
import warningOctagonIcon from "./warning-octagon.svg"
import calendarIcon from "./calendar-icon.svg"
import cancelledIcon from "./cancelled-icon.svg"

function MastercardLogo() {
	return <img src={mastercardLogo} />
}

function VisaLogo() {
	return <img src={visaLogo} />
}

function Eligible() {
	return <img src={eligible} />
}

function NotEligible() {
	return <img src={redExclamationMark} />
}

function PaymentError() {
	return <img src={redExclamationMark} width={40} />
}

function ExclamationMark() {
	return <img src={exclamationMark} />
}

function CloseIcon() {
	return <img src={closeIcon} />
}

function CrossIconImage() {
	return <img src={crossIconImage} />
}

function ThickIconImage() {
	return <img src={thickIconImage} />
}

function InvalidCodeImage() {
	return <img src={invalidCodeImage} />
}

function PaymentProcessingImage() {
	return <img src={paymentProcessingImage} />
}

function PaymentCompletedImage() {
	return <img src={paymentCompletedImage} />
}

function AmountIcon() {
	return <img src={amountIcon} />
}

function FrequencyIcon() {
	return <img src={frequencyIcon} />
}

function StartDateCalendarIcon() {
	return <img src={startDateCalendarIcon} />
}

function EndDateCalendarIcon() {
	return <img src={endDateCalendarIcon} />
}

function SetupSucceededLogo() {
	return <img src={setupSucceededLogo} />
}

function AddToCalendarIcon() {
	return <img src={addToCalendarIcon} />
}

function GoogleIcon() {
	return <img src={googleIcon} />
}

function AppleIcon() {
	return <img src={appleIcon} />
}

function OutlookIcon() {
	return <img src={outlookIcon} />
}

function YellowExclamationIcon() {
	return <img src={yellowExclamationIcon} />
}

function ClockIcon() {
	return <img src={clockIcon} />
}

function GreenCheckIconV2() {
	return <img src={greenCheckIconV2} />
}

function RedCrossIcon() {
	return <img src={redCrossIcon} />
}

function ReoccurringDollarIcon() {
	return <img src={reoccuringDollarIcon} />
}

function ErrorIcon() {
	return <img src={errorIcon} />
}

function WatchIcon() {
	return <img src={watchIcon} />
}

function WalletIcon() {
	return <img src={wallet} width="100%" />
}

function BankAccountIcon() {
	return <img src={BankAccount} />
}

function DebitCardIcon() {
	return <img src={DebitCard} />
}

function CalendarCheckIcon() {
	return <img src={calendarCheckIcon} />
}

function OXXOLogo(props: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={oxxoLogo} {...props} />
}

function IndebtedLogo(props: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={indebtedLogo} {...props} alt="InDebted" />
}

function ChevronForwardIcon(props?: ImgHTMLAttributes<HTMLImageElement>) {
	return <RotateImage src={chevronForwardIcon} {...props} rotate={0} rotateIfRTL={180} />
}

export function ChevronBackwardIcon(props?: ImgHTMLAttributes<HTMLImageElement>) {
	return <RotateImage src={chevronForwardIcon} {...props} rotate={180} rotateIfRTL={0} />
}

export function ChevronUpIcon(props?: ImgHTMLAttributes<HTMLImageElement>) {
	return <RotateImage src={chevronForwardIcon} {...props} rotate={90} />
}

export function ChevronDownIcon(props?: ImgHTMLAttributes<HTMLImageElement>) {
	return <RotateImage src={chevronForwardIcon} {...props} rotate={-90} />
}

const RotateImage = styled(({rotate, rotateIfRTL, ...props}: {rotate: number; rotateIfRTL?: number}) => (
	<img {...props} />
))<{rotate: number; rotateIfRTL?: number}>`
	transform: rotate(${({rotate}) => rotate}deg);
	[dir="rtl"] & {
		transform: rotate(${({rotate, rotateIfRTL}) => (rotateIfRTL ? rotateIfRTL : rotate)}deg);
	}
`

function IndebtedLogoWithText(props: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={indebtedLogoWithText} {...props} alt="InDebted" />
}

function LockIcon(props: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={lock} {...props} />
}

function TodayIcon(props: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={today} {...props} />
}

function WarningOctagonIcon(props?: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={warningOctagonIcon} {...props} />
}

export function CalendarIcon(props?: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={calendarIcon} {...props} />
}

export function CancelledIcon(props?: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={cancelledIcon} {...props} />
}

export {
	MastercardLogo,
	VisaLogo,
	NotEligible,
	Eligible,
	ExclamationMark,
	CloseIcon,
	CrossIconImage,
	ThickIconImage,
	InvalidCodeImage,
	PaymentProcessingImage,
	PaymentCompletedImage,
	AmountIcon,
	FrequencyIcon,
	StartDateCalendarIcon,
	EndDateCalendarIcon,
	SetupSucceededLogo,
	AddToCalendarIcon,
	GoogleIcon,
	AppleIcon,
	OutlookIcon,
	YellowExclamationIcon,
	ClockIcon,
	GreenCheckIconV2,
	RedCrossIcon,
	ReoccurringDollarIcon,
	ErrorIcon,
	WatchIcon,
	WalletIcon,
	BankAccountIcon,
	DebitCardIcon,
	CalendarCheckIcon,
	PaymentError,
	OXXOLogo,
	IndebtedLogo,
	ChevronForwardIcon,
	IndebtedLogoWithText,
	LockIcon,
	TodayIcon,
	WarningOctagonIcon,
}
